import React, { useContext, useRef, useEffect, useState, useLayoutEffect } from 'react';
import cn from 'classnames';
import DropMe from 'Components/DropMe/DropMe';
import ListingModal from 'Components/ListingModal';
import { ALLOWED_UPLOADS_COUNT, PLANS } from 'Commons';
import { AppContext, AuthContext } from 'Context';
import { Header } from '../header';
import { Sidebar } from '../sidebar';
import styles from './index.module.css';

export const Page = ({
  children,
  className,
  containerClassName,
  contentClassName,
  glassCompactHeaderBG,
  id,
  isProfileHeader,
  noBottomBar,
  noDefaultBg,
  noFixedSidebar,
  noHeader,
  noRegularHeader,
  transparentCompactHeader,
  userName,
  userProfileLink,
  headerTheme,
  accessPageBackGround,
  videoBanner,
  layoutData
}) => {
  const [sidebarIsVisible, setSidebarVisibility] = useState(false);
  const { autoSignIn } = useContext(AppContext);
  const revealSidebar = () => { setSidebarVisibility(true); };
  const hideSidebar = () => { setSidebarVisibility(false); };
  const [droper, setDroper] = useState(false);
  const [videoFiles, setVideoFiles] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);
  const [uploadModalIsVisible, setUploadModalVisibility] = useState(false);
const [popUpModalVisible, setPopUpModalVisible] = useState(false);
const [editLoader, setEditLoader] = useState(false);

const revealUploadModal = () => {
  localStorage.setItem('opened_draft_id', null);
  autoSignIn().then((res) => {
    if (!res?.data?.subscription && res?.data?.totalContentUploaded >= ALLOWED_UPLOADS_COUNT) {
      setPopUpModalVisible(true);
      setEditLoader(false);
    } else {
      setUploadModalVisibility(true);
      setEditLoader(false);
    }
  });
};

const dragOver = (e) => {
  e.preventDefault();
  setDroper(true);
};
const dragLeave = (e) => {
  e.preventDefault();
  setDroper(false);
};
const hideUploadModal = () => {
  setUploadModalVisibility(false);
};
useEffect(() => {
  document.addEventListener('dragover', dragOver);
  document.addEventListener('dragleave', dragLeave);
  return () => {
    document.removeEventListener('dragover', dragOver);
    document.removeEventListener('dragleave', dragLeave);
  };
}, []);
const [open, setOpen] = useState(false);
const handleOpen = () => setOpen(true);
const handleDrop = (e) => {
  // setEditLoader(true);
  e.preventDefault();
  const files = Array.from(e.dataTransfer.files);
  const videoFiles = files.filter((file) => file.type.startsWith('video/'));
  const imageFiles = files.filter((file) => file.type.startsWith('image/'));
  setVideoFiles(videoFiles);
  setImageFiles(imageFiles);
  revealUploadModal();
  handleOpen();
  setDroper(false);
  // if (imageFiles) {
  //   revealUploadModal();
  // } else {
  //   handleOpen();
  // }
};
  return (
    <div
      // onDrop={handleDrop}
      // onDragOver={(e) => dragOver(e)}
      // onDragLeave={(e) => dragLeave(e)}
      className={cn({ [containerClassName]: containerClassName })}
    >
      <Header
        glassCompactHeaderBG={glassCompactHeaderBG}
        isProfileHeader={isProfileHeader}
        noHeader={noHeader}
        noRegularHeader={noRegularHeader}
        onMenuClick={revealSidebar}
        transparentCompactHeader={transparentCompactHeader}
        userName={userName}
        userProfileLink={userProfileLink}
        headerTheme={headerTheme}
        videoBanner={videoBanner}
        layoutData={layoutData}
      />
      <main className={cn({
      [styles.page]: true,
      [styles.pageBottom]: !accessPageBackGround,
      [styles.noDefaultBg]: noDefaultBg,
      [styles.accessPageBackGround]: accessPageBackGround,
      [styles.holdMe]: window.location.pathname === '/your-videos', // Conditionally apply styles.holdMe
      [className]: className
      })}
      >
           {/* { droper && <DropMe dragLeave={dragLeave} dragOver={dragOver} handleDrop={handleDrop} />}
           {open && <ListingModal setOpen={setOpen} setEditLoader={setEditLoader} videoFiles={videoFiles} />} */}
        {/* <div className={styles.sidebarWrapperFixed}> */}
          <Sidebar
            noBottomBar={noBottomBar}
            noFixedSidebar={noFixedSidebar}
            onClose={hideSidebar}
            sidebarIsVisible={sidebarIsVisible}
          />
        {/* </div> */}
        {/* <div className={styles.contentWrapper}> */}
          <div className={cn({ [styles.pageContent]: true, [styles.pageContentBottom]: !accessPageBackGround, [contentClassName]: contentClassName })} id={id}>
            {children}
          </div>
        {/* </div> */}
      </main>
    </div>
  );
};
